import FlowioIconInput from "./FlowioIconInput";

export default FlowioIconInput;

export type { FlowioIconInputProps } from "./FlowioIconInput";
